"use client"; // 确保组件只在客户端渲染
import { z } from 'zod'
// import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import React, { useContext, useMemo } from 'react'
import { Button } from 'components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'components/ui/card'
import { AppContext } from '@/contexts/AppContext'
// import { RegisterFormSchema } from '@/lib/api/register'
import { Form } from '@/components/ui/form'
// import { LoginFormSchema } from '@/lib/api/login'

// import { capitalizeFirstLetter, FieldRender, FormFieldConfig } from './field-render'

const formConfig = {
  signin: {
    formTitle: 'Sign in',
    action: 'login',
    url: '/login',
    formFieldsConfig: [
      // {
      //   field: 'username',
      //   type: 'text',
      // },
      // {
      //   field: 'password',
      //   type: 'password',
      //   renderLabel: (label: string) => (
      //     <div className='flex justify-between items-baseline'>
      //       <div>{label}</div>
      //       <Link href='#' className='text-sm underline inline-block'>
      //         Forgot your password?
      //       </Link>
      //     </div>
      //   ),
      // },
    ] as FormFieldConfig<z.infer<typeof LoginFormSchema>>[],
  },
  signup: {
    formTitle: 'Sign up',
    action: 'register',
    url: '/signup',
    formFieldsConfig: [
      // {
      //   field: 'username',
      //   type: 'text',
      // },
      // {
      //   field: 'password',
      //   type: 'password',
      // },
      // {
      //   field: 'password2',
      //   type: 'password',
      // },
    ] as FormFieldConfig<z.infer<typeof RegisterFormSchema>>[],
  },
}

export type LoginFormProps = {
  isLogin: boolean
}

export function LoginForm({ isLogin }: LoginFormProps) {
  // const { handleLogin, handleRegister } = useContext(AppContext)
  const { handleGoogleLogin, logout: handleGoogleLogout } = useContext(AppContext)
  const config = useMemo(() => formConfig[isLogin ? 'signin' : 'signup'], [isLogin])

  const loginForm = useForm<z.infer<typeof LoginFormSchema>>({
    // resolver: zodResolver(LoginFormSchema),
    // defaultValues: {
    //   username: '',
    //   password: '',
    // },
  })

  const registerForm = useForm<z.infer<typeof RegisterFormSchema>>({
    // resolver: zodResolver(RegisterFormSchema),
    // defaultValues: {
    //   username: '',
    //   password: '',
    //   password2: '',
    // },
  })

  function onSubmit() {
    if (isLogin) {
      handleGoogleLogin()
    } else {
      handleGoogleLogout()
    }
  }

  const form = isLogin ? loginForm : registerForm
  const { jumpText } = useContext(AppContext)

  return (
    // eslint-disable-next-line
    <Form {...(form as any)}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className='flex flex-col items-center bg-background mt-16'>
          <Card className='mx-auto max-w-sm'>
            <CardHeader>
              <p className='text-sm text-muted-foreground'>{jumpText}</p>
              <CardTitle className='text-2xl'>{config.formTitle}</CardTitle>
              {isLogin ? (
                <CardDescription>
                  Enter your email below to {config.action} to your account
                </CardDescription>
              ) : (
                <CardDescription>
                  Enter your email below to {config.action} to your account
                </CardDescription>
              )}
            </CardHeader>

            <CardContent className='space-y-3'>
              {/* {config.formFieldsConfig.map(config => FieldRender(config, form))} */}
              <div className='grid gap-4'>
                {/* <Button
                  type='submit'
                  className='w-full bg-primary-color-1 hover:bg-primary-color-1 hover:opacity-90'
                >
                  {capitalizeFirstLetter(config.action)}
                </Button> */}
                <Button
                  type='submit'
                //   className='w-full bg-primary-color hover:bg-primary-color hover:opacity-90'
                  className='w-full hover:opacity-90'
                >
                  Login with Google
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </form>
    </Form>
  )
}
